import React, { FC, useCallback, useEffect, useState } from "react";
import { LayoutProps } from "./Layout.props";
import Navbar from "@components/landing/Navbar/Navbar";
import MobileNavbar from "@components/landing/Navbar/MobileNavbar";
import Footer from "@components/landing/Footer/Footer";
import { useIsMobile } from "hooks/useIsMobile";

import LoginProcess from "@components/auth/LoginProcess/LoginProcess";
import RegisterProcess from "@components/auth/RegisterProcess/RegisterProcess";

const LandingLayout: FC<LayoutProps> = ({ children }) => {
	const isMobile = useIsMobile();

	const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
	const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);

	useEffect(() => {
		console.log("[LandingLayout] mounted");
		return () => console.log("[LandingLayout] unmounted");
	}, []);

	const openLogin = useCallback(() => setIsLoginModalOpen(true), []);
	const openRegister = useCallback(() => setIsRegisterModalOpen(true), []);
	const closeLogin = useCallback(() => setIsLoginModalOpen(false), []);
	const closeRegister = useCallback(() => {
		console.log("[LandingLayout] closeRegister called");
		setIsRegisterModalOpen(false);
	}, []);
	return (
		<div className="grid grid-cols-1 grid-flow-row auto-rows-max gap-6 min-h-screen px-4 md:px-20 py-4 grid-rows-maxFrMax bg-light-bgColor dark:bg-dark-bgColor">
			{isMobile ? (
				<MobileNavbar onOpenLogin={openLogin} onOpenRegister={openRegister} />
			) : (
				<Navbar onOpenLogin={openLogin} onOpenRegister={openRegister} />
			)}

			{children}

			<Footer onOpenLogin={openLogin} onOpenRegister={openRegister} />

			{/* ✅ Render MODALS ONCE here */}
			<LoginProcess isModalOpen={isLoginModalOpen} onClose={closeLogin} />
			<RegisterProcess
				isModalOpen={isRegisterModalOpen}
				onClose={closeRegister}
			/>
		</div>
	);
};

export default LandingLayout;
